var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoAreaService = function SvgIcoAreaService(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (/*#__PURE__*/React.createElement("svg", _extends({
      width: 48,
      height: 48,
      viewBox: "0 0 48 48",
      fill: "none",
      ref: svgRef
    }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M24 16.84C23.2662 16.84 22.549 17.0576 21.9388 17.4652C21.3287 17.8729 20.8532 18.4523 20.5724 19.1302C20.2916 19.8082 20.2181 20.5541 20.3613 21.2738C20.5044 21.9935 20.8578 22.6545 21.3766 23.1734C21.8955 23.6922 22.5566 24.0456 23.2762 24.1887C23.9959 24.3319 24.7419 24.2584 25.4198 23.9776C26.0977 23.6968 26.6771 23.2213 27.0848 22.6112C27.4924 22.0011 27.71 21.2838 27.71 20.55C27.71 19.566 27.3191 18.6224 26.6234 17.9266C25.9276 17.2309 24.984 16.84 24 16.84Z",
      fill: "currentColor"
    })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
      d: "M36.86 7.69001C33.4506 4.27932 28.826 2.36269 24.0035 2.36176C19.181 2.36082 14.5557 4.27565 11.145 7.68501C7.73431 11.0944 5.81768 15.719 5.81674 20.5415C5.8158 25.364 7.73064 29.9893 11.14 33.4L24 46.26L36.86 33.4C40.2668 29.9893 42.1805 25.3657 42.1805 20.545C42.1805 15.7243 40.2668 11.1007 36.86 7.69001ZM34.73 31.28L24 42L13.27 31.28C11.1459 29.1575 9.69909 26.4527 9.11248 23.5078C8.52586 20.5628 8.82584 17.5101 9.97445 14.7356C11.1231 11.9612 13.0687 9.58979 15.5653 7.9213C18.0619 6.25281 20.9972 5.36225 24 5.36225C27.0028 5.36225 29.9381 6.25281 32.4347 7.9213C34.9313 9.58979 36.8769 11.9612 38.0255 14.7356C39.1741 17.5101 39.4741 20.5628 38.8875 23.5078C38.3009 26.4527 36.8541 29.1575 34.73 31.28Z",
      fill: "currentColor"
    })))
  );
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return (/*#__PURE__*/React.createElement(SvgIcoAreaService, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ico_area_service.984d638f.svg";
export { ForwardRef as ReactComponent };